'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dWeek$002dDay$002dPayload from "./presto.types$-Week-Day-Payload.js";
var $p;
/** @constructor */
function $c_Lpresto_types$WeekDayPayload$() {
}
export { $c_Lpresto_types$WeekDayPayload$ as $c_Lpresto_types$WeekDayPayload$ };
$p = $c_Lpresto_types$WeekDayPayload$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$WeekDayPayload$;
/** @constructor */
function $h_Lpresto_types$WeekDayPayload$() {
}
export { $h_Lpresto_types$WeekDayPayload$ as $h_Lpresto_types$WeekDayPayload$ };
$h_Lpresto_types$WeekDayPayload$.prototype = $p;
$p.l = (function() {
  return "WeekDayPayload";
});
$p.cG7 = (function(x$0) {
  return new $j_presto$002etypes$0024$002dWeek$002dDay$002dPayload.$c_Lpresto_types$WeekDayPayload(x$0.j(0), x$0.j(1));
});
var $d_Lpresto_types$WeekDayPayload$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$WeekDayPayload$, "presto.types$WeekDayPayload$", ({
  a37: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$WeekDayPayload$ as $d_Lpresto_types$WeekDayPayload$ };
var $n_Lpresto_types$WeekDayPayload$;
function $m_Lpresto_types$WeekDayPayload$() {
  if ((!$n_Lpresto_types$WeekDayPayload$)) {
    $n_Lpresto_types$WeekDayPayload$ = new $c_Lpresto_types$WeekDayPayload$();
  }
  return $n_Lpresto_types$WeekDayPayload$;
}
export { $m_Lpresto_types$WeekDayPayload$ as $m_Lpresto_types$WeekDayPayload$ };
//# sourceMappingURL=presto.types$-Week-Day-Payload$.js.map
